import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import { blue, green, red, yellow } from '@mui/material/colors';
import { motion } from 'framer-motion';

const BarraInterna = motion(Box);

const colors = {
    'success': {
        background: green[100],
        foreground: green[500],
    },
    'error': {
        background: red[100],
        foreground: red[500],
    },
    'info': {
        background: blue[100],
        foreground: blue[500],
    },
    'warning': {
        background: yellow[100],
        foreground: yellow[700],
    },

}


export default function LinearProgressWithLabel({color, value}) {
    // Pega o valor e converte em percentual
    const percentValor = parseInt(value * 100);

    return (
        <Box sx={{  'position': 'relative', height: 24, borderRadius: 4, background: colors[color].background}}>
            <BarraInterna
                initial={{
                    width: 0
                }}
                key='barra-interna'
                animate={{
                    width: `${percentValor < 100 ? percentValor : 100}%`,
                }}
                exit={{
                    width: 0,
                }}
                transition={{
                    type: 'spring',
                    delay: 0.3,
                    duration: 0.3
                }}
               sx={{background: colors[color].foreground,  height: 24, borderRadius: 4 }}
            />
            <Box sx={{position: 'absolute', top: '2px', width: '100%' }}>
            <Typography  fontWeight='bold' variant='body2' align='center' sx={{color: 'black'}}>
                { isFinite(percentValor) ? (value * 100).toFixed(2) : '100.00'} %
            </Typography>

            </Box>
            
        </Box>
    )
  }
LinearProgressWithLabel.defaultProps = {
    color: 'info',
}
  //
LinearProgressWithLabel.propTypes = {
    /** Cor da barra de progresso */
    color: PropTypes.oneOf(['success', 'info', 'warning', 'error']),
    /** Valor numerico default entre 0 e 1 */
    value: PropTypes.number.isRequired,
}